import React, { Component } from 'react';
import './NewNavBar.scss';
import { Link } from 'gatsby';
import getURLParams from '../../helpers/getURLParams';
const logo = require('../../assets/icons/dochq-logo-rect.svg');
const menuIcon = require('../../assets/icons/menu.svg');
const styles = { active: { color: 'var(--doc-pink)', fontWeight: 'bold' } };
export default class NewNavBar extends Component {
	constructor(props) {
		super(props);

		this.state = {
			dropdownOpen: false,
			addedAwin: false,
			topActive: 'personal',
		};
		this.getURLParams = getURLParams.bind(this);
		this.handleScroll = handleScroll.bind(this);

		function handleScroll(event) {
			// User has scrolled, hide dropdown;
			if (this.state.isMobileVisible) {
				this.setState({ isMobileVisible: false });
			}
		}
	}
	componentWillMount() {
		if (typeof window !== 'undefined') {
			window.addEventListener('scroll', this.handleScroll);
		}
	}
	render() {
		if (this.state.addedAwin === false && typeof window !== 'undefined') {
			let body = document.getElementsByTagName('body')[0];

			let awMastertag = document.createElement('script');
			awMastertag.setAttribute('defer', 'defer');
			awMastertag.src = 'https://www.dwin1.com/19181.js';
			awMastertag.type = 'text/javascript';

			body.appendChild(awMastertag);

			this.setState({ addedAwin: true });
		}
		if (
			typeof sessionStorage !== 'undefined' &&
			typeof sessionStorage.getItem('cookiesShown') !== 'undefined' &&
			sessionStorage.getItem('cookiesShown') !== true
		) {
			var _iub = _iub || [];

			_iub.csConfiguration = {
				lang: 'en',
				siteId: 1807825,
				gdprAppliesGlobally: false,
				consentOnScroll: false,
				whitelabel: false,
				cookiePolicyId: 47439358,
				banner: {
					acceptButtonDisplay: true,
					customizeButtonDisplay: true,
					position: 'float-top-center',
					textColor: 'white',
					backgroundColor: '#333333',
					acceptButtonColor: '#e5014d',
					acceptButtonCaptionColor: 'white',
					customizeButtonColor: '#212121',
					customizeButtonCaptionColor: 'white',
				},
			};
			typeof window !== 'undefined' ? (window._iub = _iub) : null;
			sessionStorage.setItem('cookiesShown', true);
		}

		return (
			<React.Fragment>
				<nav role='navigation'>
					<div className='navigation-container'>
						<img src={logo} alt='DocHQ Logo' />
						<div className={`navigation-items ${this.state.isMobileVisible ? 'mobile-nav' : ''}`}>
							<React.Fragment>
								<Link to='/' activeStyle={styles.active}>
									<div className='nav-item'>Home</div>
								</Link>
								{/* <Link to='/how-doc-hq-works' activeStyle={styles.active}>
									<div className='nav-item'>How it Works</div>
								</Link> */}
								<Link to='/partnerships' activeStyle={styles.active}>
									<div className='nav-item'>Partnerships</div>
								</Link>
								{/* <Link to='/faqs' activeStyle={styles.active}>
									<div className='nav-item'>FAQs</div>
								</Link> */}
							</React.Fragment>
							<Link to='/about-us' activeStyle={styles.active}>
								<div className='nav-item'>About Us</div>
							</Link>
							<Link to='/contact-us' activeStyle={styles.active}>
								<div className='nav-item'>Contact</div>
							</Link>
							{/* <LinkButton text='Login' linkSrc='https://login.dochq.co.uk' /> */}
						</div>
						<div
							className='menu-bar display-on-sm'
							role='navigation'
							onClick={() => {
								this.setState(prevState => ({ isMobileVisible: !prevState.isMobileVisible }));
							}}
						>
							{this.state.isMobileVisible ? (
								<i className='fa fa-chevron-right fa-2x'></i>
							) : (
								<img src={menuIcon} alt='Menu Dropdown Toggle' />
							)}
						</div>
					</div>
				</nav>
			</React.Fragment>
		);
	}
}
/*
          Business home
              how it works
							partnerships
							pricing
              faq
              contact
              |
              personal

          Personal home
              travel vaccines
							travel medicines
							about us
 */
